var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlueCheckCircle = function SvgBlueCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#2C7EF1",
    rx: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m14.247 6.158-5.966 5.759-1.584-1.692c-.291-.275-.75-.292-1.083-.058a.764.764 0 0 0-.217 1.008l1.875 3.05c.184.283.5.458.859.458.341 0 .666-.175.85-.458.3-.392 6.025-7.217 6.025-7.217.75-.766-.159-1.441-.759-.858z",
    clipRule: "evenodd"
  })));
};
export default SvgBlueCheckCircle;